export const socials = [
  {
    id: 1,
    name: "Facebook",
    key:"facebook",
    icon: (
        <svg
            viewBox="0 0 83 82"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="41.5768" cy="40.8483" r="40.8483" fill="currentColor" />
            <g clipPath="url(#clip0_3772_6037)">
                <path
                    d="M32.1701 64H45.252V44.6074H57.0389L58.334 34.9716H45.252V30.1053C45.252 29.4632 45.5966 28.8474 46.2099 28.3933C46.8233 27.9393 47.6551 27.6842 48.5225 27.6842H58.334V18H48.5225C44.1856 18 40.0263 19.2754 36.9596 21.5455C33.8929 23.8157 32.1701 26.8947 32.1701 30.1053V34.9716H25.6291L24.334 44.6074H32.1701V64Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_3772_6037">
                    <rect
                        width="34"
                        height="46"
                        fill="white"
                        transform="translate(24.334 18)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
},
{
  id: 2,
  name: "Twitter",
  key:"twitter",
  icon: (
      <svg
          viewBox="0 0 83 82"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <circle cx="41.3161" cy="40.8483" r="40.8483" fill="currentColor" />
          <path
              d="M45.4665 37.3458L59.8809 20.4688H56.4645L43.9519 35.1223L33.9532 20.4688H22.4229L37.5404 42.6298L22.4229 60.3268H25.8393L39.055 44.8505L49.6146 60.3268H61.1449L45.4665 37.3458ZM40.7889 42.8234L39.2572 40.617L27.0692 23.0595H32.3162L42.1497 37.2291L43.6814 39.4355L56.4673 57.8556H51.2203L40.7889 42.8234Z"
              fill="white"
          />
      </svg>
  ),
},
  
    {
      id: 3,
      name: "LinkedIn",
      key:"linkedin",
      icon: (
        <svg
          viewBox="0 0 83 82"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: '100%', height: '100%' }} // Make it responsive to its container
        >
          <circle cx="41.1833" cy="40.8483" r="40.8483" fill="currentColor" />
          <path
            d="M27.4355 23.3692C27.4348 24.7247 26.8957 26.0244 25.9368 26.9824C24.9779 27.9404 23.6776 28.4782 22.3221 28.4775C20.9667 28.4768 19.667 27.9377 18.709 26.9788C17.751 26.0198 17.2132 24.7196 17.2139 23.3641C17.2145 22.0087 17.7537 20.709 18.7126 19.751C19.6715 18.793 20.9718 18.2552 22.3273 18.2559C23.6827 18.2565 24.9824 18.7956 25.9404 19.7546C26.8984 20.7135 27.4362 22.0138 27.4355 23.3692ZM27.5889 32.2621H17.3672V64.2559H27.5889V32.2621ZM43.739 32.2621H33.5685V64.2559H43.6369V47.4668C43.6369 38.114 55.8262 37.2451 55.8262 47.4668V64.2559H65.9199V43.9915C65.9199 28.2245 47.8787 28.8123 43.6369 36.5552L43.739 32.2621Z"
            fill="white"
          />
        </svg>
      ),
    }
,    
  
{
  id: 4,
  name: "Instagram",
  key:"instagram",
  icon: (
    <svg
      viewBox="0 0 83 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '100%', height: '100%' }} // Make it responsive to its container
    >
      <circle cx="41.2448" cy="40.8483" r="40.8483" fill="currentColor" />
      <path
        d="M49.6148 25.3437C51.7674 25.3502 53.83 26.2081 55.3521 27.7302C56.8742 29.2524 57.7322 31.315 57.7386 33.4676V49.7135C57.7322 51.866 56.8742 53.9286 55.3521 55.4508C53.83 56.9729 51.7674 57.8308 49.6148 57.8373H33.3689C31.2163 57.8308 29.1537 56.9729 27.6316 55.4508C26.1095 53.9286 25.2515 51.866 25.2451 49.7135V33.4676C25.2515 31.315 26.1095 29.2524 27.6316 27.7302C29.1537 26.2081 31.2163 25.3502 33.3689 25.3437H49.6148ZM49.6148 22.0947H33.3689C27.1137 22.0947 21.9961 27.2124 21.9961 33.4676V49.7135C21.9961 55.9686 27.1137 61.0863 33.3689 61.0863H49.6148C55.87 61.0863 60.9876 55.9686 60.9876 49.7135V33.4676C60.9876 27.2124 55.87 22.0947 49.6148 22.0947ZM41.6335 33.1626C36.2871 33.1626 31.7782 37.6738 31.7782 43.0202C31.7782 48.3666 36.2871 52.8778 41.6335 52.8778C46.9799 52.8778 51.4887 48.3666 51.4887 43.0202C51.4887 37.6738 46.9799 33.1626 41.6335 33.1626ZM41.6335 48.8351C38.3058 48.8351 35.4939 46.0232 35.4939 43.0202C35.4939 39.0172 38.3058 36.2053 41.6335 36.2053C44.9612 36.2053 47.7731 39.0172 47.7731 43.0202C47.7731 46.0232 44.9612 48.8351 41.6335 48.8351ZM53.4178 26.4323C53.4178 26.6051 53.3349 26.7888 53.1985 26.9252C53.0621 27.0616 52.8784 27.1445 52.7056 27.1445C52.5329 27.1445 52.3492 27.0616 52.2128 26.9252C52.0764 26.7888 51.9935 26.6051 51.9935 26.4323C51.9935 26.2596 52.0764 26.0759 52.2128 25.9395C52.3492 25.8031 52.5329 25.7202 52.7056 25.7202C52.8784 25.7202 53.0621 25.8031 53.1985 25.9395C53.3349 26.0759 53.4178 26.2596 53.4178 26.4323Z"
        fill="white"
      />
    </svg>
  ),
}
,

{
  id: 5,
  name: "Reddit",
  key:"reddit",
  icon: (
    <svg
      viewBox="0 0 83 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '100%', height: '100%' }} // Make it responsive to its container
    >
      <circle cx="41.2731" cy="40.8483" r="40.8483" fill="currentColor" />
      <path
        d="M63.3925 40.9615C63.2925 38.2565 61.0212 36.1442 58.308 36.236C57.1056 36.2778 55.9621 36.7704 55.094 37.5967C51.2702 34.9917 46.7783 33.5639 42.161 33.4639L44.3398 22.9858L51.5284 24.4973C51.7284 26.3424 53.3817 27.6785 55.2269 27.4777C57.072 27.2776 58.408 25.6243 58.2073 23.7792C58.0065 21.9341 56.3539 20.598 54.5088 20.7988C53.4482 20.9071 52.4965 21.5251 51.971 22.4439L43.7389 20.7988C43.1799 20.6734 42.62 21.0242 42.4947 21.5923C42.4947 21.6005 42.4947 21.6005 42.4947 21.6087L40.0151 33.2638C35.3396 33.3392 30.7895 34.7753 26.9157 37.3967C24.9451 35.5433 21.8394 35.6351 19.986 37.6139C18.1327 39.5844 18.2245 42.6902 20.2032 44.5435C20.5876 44.9025 21.0295 45.2115 21.5221 45.4287C21.4885 45.9214 21.4885 46.414 21.5221 46.9066C21.5221 54.4289 30.2887 60.5487 41.1004 60.5487C51.9121 60.5487 60.6786 54.4371 60.6786 46.9066C60.7122 46.414 60.7122 45.9214 60.6786 45.4287C62.3655 44.5853 63.4261 42.8484 63.3925 40.9615ZM29.8043 44.3263C29.8043 42.473 31.3157 40.9615 33.1691 40.9615C35.0224 40.9615 36.5339 42.473 36.5339 44.3263C36.5339 46.1796 35.0224 47.6911 33.1691 47.6911C31.3075 47.6739 29.8043 46.1796 29.8043 44.3263ZM49.3161 53.6937V53.5601C46.9283 55.3552 44.0061 56.2733 41.0168 56.1486C38.0274 56.274 35.106 55.3552 32.7175 53.5601C32.4003 53.1757 32.4585 52.6002 32.8429 52.283C33.1765 52.0076 33.6527 52.0076 33.9953 52.283C36.0158 53.7609 38.479 54.5125 40.9832 54.3953C43.4881 54.5289 45.9595 53.8109 48.0046 52.3502C48.3719 51.9911 48.9727 51.9994 49.3325 52.3666C49.6915 52.7338 49.6833 53.3347 49.3161 53.6937ZM48.857 47.9329C48.7988 47.9329 48.7488 47.9329 48.6898 47.9329L48.7152 47.8075C46.8619 47.8075 45.3504 46.2961 45.3504 44.4427C45.3504 42.5894 46.8619 41.0779 48.7152 41.0779C50.5685 41.0779 52.08 42.5894 52.08 44.4427C52.1546 46.2968 50.7103 47.8575 48.857 47.9329Z"
        fill="white"
      />
    </svg>
  ),
}

  ];
  